var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotQualified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1uui1122,.cls-2uui1122,.cls-3uui1122,.cls-4uui1122{fill:none;}.cls-1uui1122,.cls-5uui1122{stroke-width:0px;}.cls-2uui1122{stroke-dasharray:0 0 0 6;stroke-linecap:round;stroke-width:2px;}.cls-2uui1122,.cls-3uui1122,.cls-4uui1122{stroke-miterlimit:10;}.cls-2uui1122,.cls-4uui1122{stroke:#004f68;}.cls-3uui1122{stroke:#e0e0bb;stroke-width:17px;}.cls-5uui1122{fill:#e0e0bb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1uui1122",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2uui1122",
    d: "m251.74,264.13h-115.53c-16.56,0-31.39-8.56-39.67-22.9-8.28-14.34-8.28-31.46,0-45.8l55.46-96.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2uui1122",
    d: "m179.35,52c8.28-14.34,23.11-22.9,39.67-22.9s31.39,8.56,39.67,22.9l82.81,143.43c8.28,14.34,8.28,31.46,0,45.81-8.28,14.34-23.11,22.9-39.67,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3uui1122",
    d: "m326.69,203.97L243.88,60.55c-11.05-19.14-38.68-19.14-49.73,0l-82.81,143.43c-11.05,19.14,2.76,43.07,24.87,43.07h165.61c22.1,0,35.92-23.93,24.87-43.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4uui1122",
    d: "m136.21,229.95c-6.06,0-9.06-4.06-10.07-5.81-1.01-1.75-3.03-6.38,0-11.62l82.81-143.43c3.03-5.25,8.05-5.81,10.07-5.81s7.04.57,10.07,5.81l82.81,143.43c3.03,5.25,1.01,9.88,0,11.62-1.01,1.75-4.01,5.81-10.07,5.81h-165.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5uui1122",
    d: "m204.33,113.07h29.37l-8.01,65.49h-13.22l-8.14-65.49Zm3.31,75.53h22.76v20.73h-22.76v-20.73Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4uui1122",
    points: "204.33 113.07 233.7 113.07 225.69 178.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4uui1122",
    points: "207.63 188.6 230.4 188.6 230.4 209.33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotQualified);
export default __webpack_public_path__ + "static/media/not-qualified.57e2ffb7403ecffadad146b7b7380430.svg";
export { ForwardRef as ReactComponent };